import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../../../constants/path';
import { APP_NAME, HAS_INSTANT_DISCOUNT, NO_DISCOUNT, USE_PARITY } from '../../../../../constants';

import { doRewriteUrl } from '../../../../../services/interstitiel/actions';

import { getI18nByApp } from '../../../../../services/i18n/selector';

import { formatAmountCurrency, formatAmountParity } from '../../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import LinkButtonComponent from '../../../../button/LinkButtonComponent';

import { MessageContainer } from './ConfirmationEbonPageMessageBlocStyle';

const FixedValueBloc = ({
    partnerName,
    sessionEmail,
    urlRewritten,
    redirectUri,
    redirectLabel,
    amount,
    i18n
}) => {
    const cashbackAmount = USE_PARITY ? formatAmountParity(amount) : formatAmountCurrency(amount);

    return (
        <div>
            <h1>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.TITLE')}</h1>

            <MessageContainer>
                <h3>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FIXED_FACIAL_VALUE.TEXT_1')}</h3>
                <p>
                    {sessionEmail
                        ? convertHtmlToReactDomWithParams(
                              getI18nByApp(
                                  i18n,
                                  'page.EBON.CONFIRMATION.FIXED_FACIAL_VALUE.TEXT_2'
                              ),
                              sessionEmail
                          )
                        : getI18nByApp(
                              i18n,
                              'page.EBON.CONFIRMATION.FIXED_FACIAL_VALUE.TEXT_2_ALT'
                          )}
                </p>

                {!NO_DISCOUNT && !HAS_INSTANT_DISCOUNT && !!amount && amount > 0 && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FIXED_FACIAL_VALUE.TEXT_3'),
                            cashbackAmount,
                            APP_NAME
                        )}
                    </p>
                )}

                <p>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.SPAM_MESSAGE')}</p>

                {HAS_INSTANT_DISCOUNT && urlRewritten && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_MERCHANT_WEBSITE'),
                            partnerName,
                            urlRewritten
                        )}
                    </p>
                )}
            </MessageContainer>

            {redirectUri ? (
                <p>
                    <a href={redirectUri} rel={'external'}>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT'),
                            redirectLabel
                        )}
                    </a>
                </p>
            ) : (
                <LinkButtonComponent
                    to={PATH.HOME_PATH}
                    text={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_HOME')}
                    title={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_HOME')}
                    color="main"
                />
            )}
        </div>
    );
};

FixedValueBloc.propTypes = {
    partnerName: PropTypes.string,
    sessionEmail: PropTypes.string,
    urlRewritten: PropTypes.string,
    redirectUri: PropTypes.string,
    redirectLabel: PropTypes.string,
    amount: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n
    };
};

const mapDispatchToProps = {
    doRewriteUrl
};

export default connect(mapStateToProps, mapDispatchToProps)(FixedValueBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/FixedValueBloc.js